import { ProductFront } from "@project/shared-types";
import React, { createContext, ReactNode, useEffect, useRef } from "react";
import { GetProductsAllAPI } from "../api/productsApi";
import { useTemporaryStorage } from "./useLocalStoreg";

// Create the context
export const DataContext = createContext<{
  products: ProductFront[];
  updateData: (path: string) => Promise<void>;
}>({
  products: [],
  updateData: async () => {},
});

// DataProvider component
export const DataProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [products, setProducts] = useTemporaryStorage<ProductFront[]>(
    "productsv2",
    []
  );
  const loading = useRef(false);

  const updateData = async () => {
    try {
      const response = await GetProductsAllAPI({});
      setProducts(response.products);
    } catch (error) {
      console.error("Ошибка при загрузке данных:", error);
    }
  };

  useEffect(() => {
    console.log("products", products);
    if (products.length === 0 && !loading.current) {
      loading.current = true;
      updateData();
      loading.current = false;
    }
  }, []);

  return (
    <DataContext.Provider value={{ products, updateData }}>
      {children}
    </DataContext.Provider>
  );
};

export const useData = () => {
  return React.useContext(DataContext);
};
